import { useEnvironment } from '@wix/yoshi-flow-editor';
import { SECTION_HOMEPAGE } from '@wix/communities-blog-client-common';
import { useSelector } from '../components/runtime-context';
import { getAppSettingsNumber } from '../selectors/app-settings-base-selectors';
import { getSection } from '../selectors/section-selectors';
import useIsFeedDesignEnabled from './use-is-feed-design-enabled';

export function useFeedBorderRadius() {
  const { applyFeedDesign } = useIsFeedDesignEnabled();
  const section = useSelector(getSection) || SECTION_HOMEPAGE;
  const { isMobile } = useEnvironment();
  const feedBorderRadius = useSelector((state) =>
    getAppSettingsNumber(
      state,
      isMobile ? `post-${section}-mobile-postRadius` : `post-${section}-postRadius`,
      0,
    ),
  );

  return { borderRadius: applyFeedDesign ? feedBorderRadius : 0 };
}
